<template>
  <div class="h-22 pt-2">
    <div class="w-84 px-2 z-20 flex justify-end">
      <multiSelect
        v-if="!editModeActive"
        v-model="value"
        :options="options"
        :multiple="true"
        :close-on-select="false"
        :clear-on-select="true"
        :placeholder="$t('filter.chooseBoards')"
        label="name"
        track-by="name"
        :selectLabel="$t('actions.select')"
        :deselectLabel="$t('actions.remove')"
        @open="openDropdown"
        @close="updateDropdownHandler"
      >
        <template slot="selection" slot-scope="{ values, isOpen }"
          ><span class="multiselect__single" v-if="values.length && !isOpen"
            >{{ values.length }} {{ $t("filter.boardsSelected") }}</span
          ></template
        >
      </multiSelect>
      <FilterButton v-if="editModeActive" @click="$emit('cancel')" icon="close" :tooltip="$t('actions.cancel')" />
      <FilterButton
        v-if="selectedBoards && !editModeActive"
        @click="$emit('edit')"
        icon="sort"
        :disabled="!selectedBoards.length"
        :tooltip="$t('actions.sort')"
      />
      <FilterButton
        v-if="selectedBoards && editModeActive"
        @click="$emit('save')"
        icon="save"
        :tooltip="$t('actions.save')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onBeforeMount, computed, watch } from "vue";
import multiSelect from "vue-multiselect";
import FilterButton from "@/components/Buttons/FilterButton.vue";
import { Board } from "@/types/board";
import { useBoardStore } from "@/store/board/BoardStore";
import { useBrickStore } from "@/store/brick/BrickStore";
import { useFleetStore } from "@/store/fleet/FleetStore";

export default defineComponent({
  name: "boardFilter",
  components: { multiSelect, FilterButton },
  props: {
    editModeActive: {
      type: Boolean
    }
  },
  setup() {
    const boardStore = useBoardStore();
    const brickStore = useBrickStore();
    const fleetStore = useFleetStore();

    const value = ref<Board[]>([]);
    const options = computed(() => boardStore.boards);
    const selectedBoards = computed(() => boardStore.boardsSelected);

    onBeforeMount(() => {
      boardStore.initBoardsDropdown();
    });

    watch(selectedBoards, last => {
      value.value = last!;
    });

    const updateDropdownHandler = (value: Board[]): void => {
      if (value !== selectedBoards.value) {
        boardStore.boardsSelected = value.map(board => ({ name: board.id, id: board.id }));

        fleetStore.clearFleet();
        brickStore.resetLegs();
        fleetStore.removeSelectedTrailers();
        brickStore.resetFleetActions();

        if (selectedBoards.value!.length > 0) {
          const boardIds: string[] = boardStore.boardsSelected!.map(board => board.id);
          fleetStore.fetchBoardFleet(boardIds);
        }

        boardStore.updateConfigProfile();
        boardStore.getFilteredBoardProfile();
      }
      //scroll always to top when changing selection
      window.scrollTo(0, 0);
      fleetStore.activateDriverCommentToggle();
    };

    const openDropdown = (): void => {
      fleetStore.deactivateDriverCommentToggle();
    };

    return { value, options, updateDropdownHandler, openDropdown, selectedBoards };
  }
});
</script>

<style scoped lang="scss">
@use "BoardFilter";
</style>
